"use client";

import * as React from "react";
import { Star, Quote } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Card, CardContent } from "@/components/ui/card";
export default function TheClipCraftCommunity() {
  const testimonials = [{
    author: "Robert Chen",
    quote: "The precision of the laser engraving on our aerospace components was surgical. Quinn Studio delivered exactly what we needed for the final assembly.",
    position: "Senior Systems Engineer"
  }, {
    author: "Elena Rodriguez",
    quote: "3D printing complex geometries used to be a bottleneck. Now, it's our most reliable phase of production thanks to their technical expertise.",
    position: "Product Development Lead"
  }, {
    author: "Marcus Thorne",
    quote: "Their Digital Design work transformed our industrial facility into a high-tech showroom. The balance of technical form and function is impeccable.",
    position: "Architectural Director"
  }, {
    author: "Sarah Jenkins",
    quote: "Exceptional attention to detail. The circuit-inspired lighting fixtures they manufactured are the centerpiece of our new headquarters.",
    position: "Operations Manager"
  }];
  return <section data-section-id="43418" id="client-success-stories" className="bg-background text-foreground py-24 overflow-hidden relative">
      <div className="container mx-auto px-4 md:px-8">
        <div className="mb-16 text-center">
          <h2 className="text-4xl md:text-5xl font-bold tracking-tighter uppercase mb-4 text-primary">
            Client Success Stories
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto font-mono text-sm tracking-widest uppercase">
            Industrial Precision Validated by Industry Leaders.
          </p>
        </div>

        <div className="relative">
          <Carousel opts={{
          align: "start",
          loop: true
        }} className="w-full">
            <CarouselContent className="-ml-4">
              {testimonials.map((testimonial, i) => <CarouselItem key={i} data-index={i} className="pl-4 md:basis-1/2 lg:basis-1/3">
                  <div className="h-full">
                    <Card className="h-full bg-card border-0 border-l-2 border-l-foreground rounded-none shadow-none hover:bg-muted/50 transition-colors duration-300">
                      <CardContent className="p-8 flex flex-col justify-between h-full gap-6">
                        <Quote className="size-8 text-foreground/10" />
                        <blockquote className="text-xl md:text-2xl italic font-serif leading-relaxed text-foreground">
                          "{testimonial.quote}"
                        </blockquote>
                        <div className="mt-auto">
                          <cite className="not-italic block font-mono text-foreground text-lg tracking-wider uppercase">
                            {testimonial.author}
                          </cite>
                          <span className="text-xs text-muted-foreground font-medium uppercase tracking-widest mt-1 block">
                            {testimonial.position}
                          </span>
                        </div>
                      </CardContent>
                    </Card>
                  </div>
                </CarouselItem>)}
            </CarouselContent>
            <div className="flex justify-end gap-2 mt-8 pr-4">
              <CarouselPrevious className="static translate-y-0 translate-x-0 rounded-none border-foreground hover:bg-foreground hover:text-background hover:border-foreground transition-all duration-200" />
              <CarouselNext className="static translate-y-0 translate-x-0 rounded-none border-foreground hover:bg-foreground hover:text-background hover:border-foreground transition-all duration-200" />
            </div>
          </Carousel>
        </div>

        <div className="mt-20 flex justify-center">
          <div className="inline-flex items-center gap-6 border border-border px-8 py-4 bg-card/30 backdrop-blur-sm">
            <div className="flex flex-col">
              <div className="flex items-center gap-1 mb-1">
                {[1, 2, 3, 4, 5].map((star, i) => <Star key={i} data-index={i} className="size-5 fill-foreground text-foreground" />)}
              </div>
              <span className="text-xs font-mono text-muted-foreground uppercase tracking-widest">
                Based on 200+ Projects
              </span>
            </div>
            <div className="h-8 w-px bg-border" />
            <div className="flex items-center gap-3">
              <span className="font-bold text-xl tracking-tight text-foreground">Rating</span>
              <span className="bg-foreground text-background text-[10px] font-bold px-1.5 py-0.5 rounded-none">
                5.0
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}